const doc = [({"en":({"js":({"agenda_item_elements":({"edit":({"document":({"choose_document_file":"Choose document"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;